module.exports = __webpack_public_path__ + "2b89e2b53b18522be537f2efd981bf59.webp";